var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import { useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { ScreenQrScanner } from './ScreenQrScanner';
import { usePairScreen } from './usePairScreen';
import { formatCode, normalizeCode, SCREEN_CODE_LENGTH } from './utils';
import { codeInputSx, primaryButtonSx, secondaryButtonSx } from './styles';
const Body = styled.div `
  width: 520px;
  max-width: 100%;
  box-sizing: border-box;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #ffffff;
  font-family: 'Roboto', sans-serif;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;
const Title = styled.div `
  font-size: 24px;
  font-weight: 600;
`;
const Status = styled.div `
  box-sizing: border-box;
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 12px;
  background: #161719;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
  font-size: 16px;
  line-height: 1.5;
  color: #c4cdd0;
`;
const ErrorText = styled.div `
  color: #cc8181;
`;
const Manual = styled.form `
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const ManualRow = styled.div `
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
`;
const Label = styled.label `
  font-size: 14px;
  color: #899295;
`;
const Info = styled.div `
  font-size: 14px;
  line-height: 1.4;
  color: #899295;
`;
// Separate component so every opening starts from a clean state and the camera stops on close
const DialogContent = ({ eventId, onClose, onPaired }) => {
    const pair = usePairScreen();
    const [phase, setPhase] = useState('scan');
    const [pairingCode, setPairingCode] = useState('');
    const [error, setError] = useState(null);
    const [manualCode, setManualCode] = useState('');
    const submit = (code) => __awaiter(void 0, void 0, void 0, function* () {
        setPairingCode(code);
        setPhase('pairing');
        const result = yield pair(code, eventId);
        if (result.screen) {
            onPaired(result.screen);
            onClose();
            return;
        }
        setError(result.error);
        setPhase('error');
    });
    const onManualSubmit = (e) => {
        e.preventDefault();
        if (manualCode.length === SCREEN_CODE_LENGTH && phase !== 'pairing')
            submit(manualCode);
    };
    return (_jsxs(Body, { children: [_jsx(Title, Object.assign({ id: "screen-pair-dialog-title" }, { children: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u044D\u043A\u0440\u0430\u043D" })), phase === 'scan' && _jsx(ScreenQrScanner, { onDetected: submit }), phase === 'pairing' && _jsx(Status, Object.assign({ role: "status" }, { children: `Подключаем экран ${formatCode(pairingCode)}…` })), phase === 'error' && (_jsxs(Status, Object.assign({ role: "alert" }, { children: [_jsx(ErrorText, { children: error }), _jsx(Button, Object.assign({ sx: primaryButtonSx, onClick: () => setPhase('scan') }, { children: "\u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0451 \u0440\u0430\u0437" }))] }))), _jsxs(Manual, Object.assign({ onSubmit: onManualSubmit }, { children: [_jsx(Label, Object.assign({ htmlFor: "screen-pair-dialog-code" }, { children: "\u0412\u0432\u0435\u0441\u0442\u0438 \u043A\u043E\u0434 \u0432\u0440\u0443\u0447\u043D\u0443\u044E" })), _jsxs(ManualRow, { children: [_jsx(FormControl, { children: _jsx(OutlinedInput, { id: "screen-pair-dialog-code", placeholder: "K7Q-42M", value: formatCode(manualCode), onChange: (e) => setManualCode(normalizeCode(e.target.value)), autoComplete: "off", inputProps: { autoCapitalize: 'characters', spellCheck: false, maxLength: SCREEN_CODE_LENGTH + 1 }, sx: codeInputSx }) }), _jsx(Button, Object.assign({ type: "submit", sx: primaryButtonSx, disabled: manualCode.length !== SCREEN_CODE_LENGTH || phase === 'pairing' }, { children: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C" }))] })] })), _jsx(Info, { children: "\u0420\u043E\u043B\u0438 \u0438 \u043D\u043E\u0447\u043D\u044B\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043D\u0430 \u044D\u043A\u0440\u0430\u043D \u043D\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u044E\u0442\u0441\u044F." }), _jsx(Button, Object.assign({ sx: secondaryButtonSx, onClick: onClose }, { children: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" }))] }));
};
export const ScreenPairDialog = ({ open, eventId, onClose, onPaired }) => (_jsx(Dialog, Object.assign({ open: open, onClose: onClose, "aria-labelledby": "screen-pair-dialog-title", PaperProps: { sx: { background: '#202224', margin: 2, width: 'calc(100% - 32px)', maxWidth: 520 } } }, { children: open && _jsx(DialogContent, { eventId: eventId, onClose: onClose, onPaired: onPaired }) })));
